import { BorrowStatus, PoolPricingMethod } from '@thinkalpha/locates-ws-client';

/** Every {@link PoolPricingMethod}, for iteration in UI code. */
export const POOL_PRICING_METHODS = [
    PoolPricingMethod.Admin,
    PoolPricingMethod.Cached,
    PoolPricingMethod.Reference,
    PoolPricingMethod.FairValue,
] as const satisfies readonly PoolPricingMethod[];

/** Every borrow status, in the design's display order. */
export const BORROW_STATUS_KEYS = [
    BorrowStatus.ETB,
    BorrowStatus.LocateRequired,
    BorrowStatus.Preborrow,
] as const satisfies readonly BorrowStatus[];
